import script from "./video.vue?vue&type=script&setup=true&lang=js"
export * from "./video.vue?vue&type=script&setup=true&lang=js"

import "./video.vue?vue&type=style&index=0&id=ed1582f0&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed1582f0"]])

export default __exports__